import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Grid2,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { BsFillPersonBadgeFill, BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import {
  allCustomer,
  allprospect,
  getAllTask,
  getEmaildetailsById,
  getOrganisationname,
  getuser,
  getUserDetail,
  getUserHierarchy,
} from "../callQuery";
import BASEURL from "../../Utils/Baseurl";
import request from "graphql-request";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import { fromGlobalId } from "../../../lib/decoded/rawPk";
import { addMailService, updateMailService } from "../callMutation";
import { useError } from "../../../context/ErrorContext";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
const AddMail = () => {
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [formData, setFormData] = useState({ fileattachment: null });
  const [fileStatus, setFileStatus] = useState({
    file: "",
    file: "unchecked",
  });
  const [selectedtData, setSelectedData] = useState([]);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });
  const { currentUser } = useAuth();

  const { id: rawPk } = fromGlobalId(currentUser?.id);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const useroptions = [
    {
      value: "customer",
      label: "Customer",
    },
    {
      value: "lead and prospect",
      label: "Prospect",
    },
    {
      value: "others",
      label: "Others",
    },
  ];
  const mailType = [
    {
      value: "incoming",
      label: "Incoming",
    },
    {
      value: "outgoing",
      label: "Outgoing",
    },
  ];
  const purposeOptions = [
    {
      value: "send",
      label: "Send Quotation",
    },
    {
      value: "support",
      label: "Appointment Request",
    },
  ];
  const params = useLocation();
  const id = params.search.slice(1);
  const [isOtherUserType, setIsOtherUserType] = useState(false);
  const [preferdOption, setPreferedOption] = useState([]);
  const [dropOption, setdropOption] = useState([]);
  const [ titleOptions, setTitleOptions ] = useState();
  const [dropOptionName, setDropOptionName] = useState([]);

  const [mailData, setmailData] = useState({
    title: "",
    titleStatus: "unchecked",
    description: "",
    descriptionStatus: "unchecked",
    organizationName: "",
    organizationNameStatus: "unchecked",
    name: "",
    nameStatus: "unchecked",
    mailTo: "",
    mailToStatus: "unchecked",
    fileattachment: null,

  });

  const [maildropData, setmaildropData] = useState({
    userType: "",
    userTypeStatus: "unchecked",
    mailType: "",
    mailTypeStatus: "unchecked",
    purpose: "",
    purposeStatus: "unchecked",
    organizationName: "",
    organizationNameStatus: "unchecked",

    preparedBy: "",
    preparedByStatus: "success",
    name: "",
    nameStatus: "unchecked",
    mailTo: "",
    mailToStatus: "unchecked",
    mailFrom: currentUser?.email,
    mailFromStatus: "success",
  });

  const [ taskData, setTaskData ] = useState({
      taskTitle: "",
      taskTitleStatus: "unchecked"
  });

  

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await request(BASEURL, getUserHierarchy, {
          id: rawPk,
        });
        setPreferedOption(response?.getUserHierarchy);
      } catch (err) {
        console.error("Error", err);
      }
    };
    fetchdata();
  }, []);

  useEffect(() => {
    setmaildropData({
      ...maildropData,
      preparedBy: {
        value: rawPk,
        label: currentUser?.username,
      },
    });
  }, []);

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

    useEffect(() => {
      fetchAllTask();
    },[]);

    //Fetch Task Title
    const fetchAllTask = async() => {
      try{
        const response = await request(BASEURL, getAllTask);
        const data = response?.allTasks?.data;
        const options = data?.map((task) => ({
          label: task.title,
          value: task.id,
        }));
        setTitleOptions(options);
        
      }
      catch(error){
        console.error("Error Fetching Data", error);
      }
    }
  
  //Fetch Data By ID
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getEmaildetailsById, {
        id: id,
      });

      const J = res.getEmaildetailsById;

      if (J.userType == "Others") {
        setIsOtherUserType(true);
        setmaildropData({
          preparedBy: {
            value: J.preparedBy?.id,
            label: J.preparedBy?.username,
          },
          userType: {
            value: J.userType,
            label: J.userType,
          },
          organizationName: {
            value: J.organisationName,
            label: J.organisationName,
          },
          name: {
            value: J.name,
            label: J.name,
          },
          mailFrom: J.fromEmail,
          mailTo: J.toEmail,
          mailType: {
            value: J.emailType,
            label: J.emailType,
          },
          purpose: {
            value: J.emailPurpose,
            label: J.emailPurpose,
          },
          preparedByStatus: "success",
          userTypeStatus: "success",
          nameStatus: "success",
          mailFromStatus: "success",
          //mailToStatus: "success",
          mailTypeStatus: "success",
          purposeStatus: "success",
          //organizationNameStatus: "success",

        });
        setTimeout(() => {
          setmailData({
            ...mailData,
            organizationName: J.organisationName,
            name: J.name,
            mailTo: J.toEmail,
            title: J.title,
            description: J.emailDescription,
            titleStatus: "success",
            descriptionStatus: "success",
            organizationNameStatus: "success",
            nameStatus: "success",
            mailToStatus: "success",
          });
          
        });
      } else {
        setmaildropData({
          preparedBy: {
            value: J.preparedBy?.id,
            label: J.preparedBy?.username,
          },
          userType: {
            value: J.userType,
            label: J.userType,
          },
          organizationName: {
            value: J.organisationName,
            label: J.organisationName,
          },
          name: {
            value: J.name,
            label: J.name,
          },
          mailFrom: J.fromEmail,
          mailTo: J.toEmail,
          mailType: {
            value: J.emailType,
            label: J.emailType,
          },
          purpose: {
            value: J.emailPurpose,
            label: J.emailPurpose,
          },
          preparedByStatus: "success",
          userTypeStatus: "success",
          mailFromStatus: "success",
          mailToStatus: "success",
          mailTypeStatus: "success",
          purposeStatus: "success",
          organizationNameStatus: "success",
          nameStatus: "unchecked",
        });
        setTaskData({
          taskTitle: {
            value: J.task.id,
            label: J.task.title,
          },
          taskTitleStatus: J.task.id ? "success" : "unchecked"
        })

        setmailData({
          ...mailData,
          organizationName: J.organisationName,
          name: J.name,
          mailTo: J.toEmail,
          title: J.title,
          description: J.emailDescription,
          titleStatus: "success",
          descriptionStatus: "success",
          nameStatus: "success",
          mailToStatus: "success",
        });
      }

      setmailData({
        title: J.title,
        description: J.emailDescription,
        titleStatus: "success",
        mailTo: J.toEmail,
        descriptionStatus: "success",
      });
      setSelectedData(J);
    } catch (err) {
      console.error(err.message, "err");
    }
  };

    //Create Mutation
  const handleAddMail = async (event) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        const values = {
          user: rawPk,
          userType: maildropData.userType?.label,

          organisationName:
            maildropData.userType.value == "others"
              ? mailData.organizationName
              : maildropData.organizationName?.label,
          name:
            maildropData.userType.value == "others"
              ? mailData.name
              : maildropData.name?.label,

          preparedById: maildropData.preparedBy?.value,
          fromEmail: maildropData.mailFrom,
          toEmail:
            maildropData.userType.value == "others"
              ? mailData.mailTo
              : maildropData.mailTo,
          title: mailData.title,
          emailType: maildropData.mailType?.label,
          emailPurpose: maildropData.purpose?.label,
          emailDescription: mailData.description,
          fileattachment: mailData.fileattachment,
          taskId: taskData.taskTitle?.value,
        };

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const callStatus = await addMailService(values);
        setCirleLoading(false);
        if (callStatus) {
          setSuccessStatus(true);
          setSucessTitle("Mail Log Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/maildetails");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  
  //Update Mutation
  const handleUpdateMail = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });

        const values = {
          userType: maildropData.userType?.label,
          organisationName:
            maildropData.userType.value == "others"
              ? mailData.organizationName
              : maildropData.organizationName?.label,
          name:
            maildropData.userType.value == "others"
              ? mailData.name
              : maildropData.name?.label,
          preparedById: maildropData.preparedBy?.value,
          fromEmail: maildropData.mailFrom,
          toEmail:
            maildropData.userType.value == "others"
              ? mailData.mailTo
              : maildropData.mailTo,
          title: mailData.title,
          emailType: maildropData.mailType?.label,
          emailPurpose: maildropData.purpose?.label,
          emailDescription: mailData.description,
          fileattachment: mailData.fileattachment,
          taskId: taskData.taskTitle?.value,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const updateStatus = await updateMailService(id, values);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Mail Log Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/maildetails");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Cancel Function
  const handleCancelMailData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        navigate("/maildetails");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

//Handle Change
  const handleMailChange = (event) => {
    let mailState = { ...mailData };
    switch (event.target.name) {
      case "title": {
        const alphaNLenghthRegex = new RegExp("^[\\s\\S]{2,50}$"); // Updated regex
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          mailState[event.target.name + "Status"] = "success";
        } else {
          mailState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "name": {
        // Regex: Ensures no numbers and allows alphabetic characters, spaces, and special characters
        const validationRegex = new RegExp(
          "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
        );

        const trimmedValue = event.target.value?.trim();
        let errorMessage = "";

        // Only validate if there's input
        if (trimmedValue !== "") {
          // Check if input contains any numbers (using a regex for numbers)
          const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

          if (containsNumbers) {
            mailState[event.target.name + "Status"] = "error";
            errorMessage = " Name should not contain numbers.";
          } else if (!validationRegex.test(trimmedValue)) {
            // If it passes the number check but fails the other character constraints
            mailState[event.target.name + "Status"] = "error";
            errorMessage = " Name should be and 30 characters long";
          } else {
            mailState[event.target.name + "Status"] = "success";
            errorMessage = ""; // Clear error message if validation passes
          }
        } else {
          // If input is empty
          mailState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
          errorMessage = ""; // No error message for empty input
        }

        // Optionally update the state with the error message
        mailState[event.target.name + "ErrorMessage"] = errorMessage;
        break;
      }
      case "description": {
        const alphaNLenghthRegex = new RegExp("^[\\s\\S]{2,500}$"); // Updated regex
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          mailState[event.target.name + "Status"] = "success";
        } else {
          mailState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "organizationName": {
        // Regex: Ensures no numbers and allows alphabetic characters, spaces, and special characters
        const validationRegex = new RegExp(
          "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
        );

        const trimmedValue = event.target.value?.trim();
        let errorMessage = "";

        // Only validate if there's input
        if (trimmedValue !== "") {
          // Check if input contains any numbers (using a regex for numbers)
          const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

          if (containsNumbers) {
            mailState[event.target.name + "Status"] = "error";
            errorMessage = "Organization Name should not contain numbers.";
          } else if (!validationRegex.test(trimmedValue)) {
            // If it passes the number check but fails the other character constraints
            mailState[event.target.name + "Status"] = "error";
            errorMessage = "Organization Name should be 30 characters long";
          } else {
            mailState[event.target.name + "Status"] = "success";
            errorMessage = ""; // Clear error message if validation passes
          }
        } else {
          // If input is empty
          mailState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
          errorMessage = ""; // No error message for empty input
        }

        // Optionally update the state with the error message
        mailState[event.target.name + "ErrorMessage"] = errorMessage;
        break;
      }

      case "mailTo": {
        const strictEmailRegex =
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|in)$/;

        if (strictEmailRegex.test(event.target.value?.trim())) {
          mailState[event.target.name + "Status"] = "success";
        } else {
          mailState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
    }
    mailState[event.target.name] = event.target.value;
    setmailData(mailState);
  };

//Handle Change for Task Title
  const handleTaskTitle = (event, selectEvent) => {
    let taskStatusState = { ...taskData };
    if(event?.target === undefined && selectEvent){
      switch(selectEvent.name){
        case "taskTitle": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            taskStatusState[selectEvent.name + "Status"] = "success";
          } else {
            taskStatusState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          break;
        }
      }
      taskStatusState[selectEvent.name] = event;
    }
    setTaskData(taskStatusState);
  };  

  const handleMailDataChange = (event, selectEvent) => {
    let fieldState = { ...maildropData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "mailType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              fieldState["mailTypeStatus"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              fieldState["mailTypeStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "purpose":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              fieldState["purposeStatus"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              fieldState["purposeStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "name":
          {
            if (event?.label !== undefined) {
              request(BASEURL, getuser, { id: event.value })
                .then((res) => {

                  setmaildropData({
                    ...maildropData,
                    name: event,
                    nameStatus: "success",
                    mailTo: res.getContactdetail.mailId,
                    mailToStatus: "success",
                  });
                })
                .catch((error) => {});
            } else {
              setmaildropData({
                ...maildropData,
                mailTo: "",
                mailToStatus: "unchecked",
              });
            }
          }
          break;
        case "userType":
          {
            if (event.value === "others") {
              setIsOtherUserType(true);
              fieldState["organizationName"] = "";
              fieldState["organizationNameStatus"] = "unchecked";
              fieldState["name"] = "";
              fieldState["nameStatus"] = "unchecked";
              fieldState["mailTo"] = "";
              fieldState["mailToStatus"] = "unchecked";

              setmailData({
                ...mailData,
                mailTo: "",
                mailToStatus:"unchecked",
                organizationName: "",
                organizationNameStatus:"unchecked",
                name: "",
                nameStatus:"unchecked"
              });
              mailData["titleStatus"] = event.value ? "success" : "unchecked";
            } else {
              setIsOtherUserType(false);
            }
            if (event.value === "customer") {
              request(BASEURL, allCustomer, {
                organisation_name: "customer",
              })
                .then((res) => {
                  console.error("Response from getOrganisationtype:", res);
                  setdropOption(res.allCustomer);
                })
                .catch(() => {});
            } else if (event.value === "lead and prospect") {
              request(BASEURL, allprospect, {
                organization: "lead and prospect",
              })
                .then((res) => {
                  setdropOption(res.allLeadprospect);
                })
                .catch((error) => {
                  console.error(
                    "Error fetching organisation type for lead and prospect:",
                    error
                  );
                });
            }

            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              fieldState["userTypeStatus"] =
                event?.label === undefined ? "unchecked" : "success";
              fieldState["nameStatus"] = "unchecked";
              fieldState["name"] = "";
              fieldState["mailTo"] = "";
              fieldState["mailToStatus"] = "unchecked";
              fieldState["organizationName"] = "";
              fieldState["organizationNameStatus"] = "unchecked";
            } else {
              fieldState["userTypeStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
              fieldState["nameStatus"] = "unchecked";
              fieldState["name"] = "";
            }
          }
          break;
        case "preparedBy": {
          if (event?.label !== undefined) {
            request(BASEURL, getUserDetail, { id: event.value })
              .then((res) => {
                setmaildropData({
                  ...maildropData,
                  preparedBy: event,
                  mailFrom: res.getUserDetail.email,
                });
              })
              .catch((error) => {});
          } else {
            setmaildropData({
              ...maildropData,
              mailTo: "",
              mailToStatus: "unchecked",
            });
          }
        }
        case "organizationName": {
          if (event?.label !== undefined) {
            request(BASEURL, getOrganisationname, {
              organisationname: event.label,
            }).then((res) => {
              setDropOptionName(res.getOrganisationname);
            });
          }
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(event?.label) === true) {
            fieldState["organizationNameStatus"] = "success";
          }
        }
      }

      fieldState[selectEvent.name] = event;
      setmaildropData(fieldState);
    }
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;

    if (
      maildropData.preparedByStatus === "success" &&
      maildropData.userTypeStatus === "success" &&
      mailData.titleStatus === "success" &&
      maildropData.mailTypeStatus === "success" &&
      maildropData.purposeStatus === "success" &&
      taskData.taskTitleStatus === "success" &&
      (isOtherUserType
        ? mailData.organizationNameStatus === "success" &&
          mailData.mailToStatus === "success"
        : maildropData.organizationNameStatus === "success" &&
          maildropData.mailToStatus === "success")
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    if (selectedtData.userType == "Others") {
      setIsOtherUserType(true);
      setmaildropData({
        preparedBy: {
          value: selectedtData.preparedBy?.id,
          label: selectedtData.preparedBy?.username,
        },
        userType: {
          value: selectedtData.userType,
          label: selectedtData.userType,
        },
        organizationName: {
          value: selectedtData.organisationName,
          label: selectedtData.organisationName,
        },
        name: {
          value: selectedtData.name,
          label: selectedtData.name,
        },
        mailFrom: selectedtData.fromEmail,
        mailTo: selectedtData.toEmail,
        mailType: {
          value: selectedtData.emailType,
          label: selectedtData.emailType,
        },
        purpose: {
          value: selectedtData.emailPurpose,
          label: selectedtData.emailPurpose,
        },
        description: selectedtData.emailDescription,
        preparedByStatus: "success",
        titleStatus: "success",
        userTypeStatus: "success",
        nameStatus: "success",
        mailFromStatus: "success",
        mailToStatus: "success",
        mailTypeStatus: "success",
        purposeStatus: "success",
        organizationNameStatus: "success",
        descriptionStatus: "success",
      });
      setmailData({
        description: selectedtData.emailDescription,
        descriptionStatus: "success",
      });
      setTimeout(() => {
        setmailData({
          ...mailData,
          organizationName: selectedtData.organisationName,
          name: selectedtData.name,
          mailTo: selectedtData.toEmail,
          title: selectedtData.title,
          description: selectedtData.emailDescription,
          titleStatus: "success",
          descriptionStatus: "success",
          organizationNameStatus: "success",
          nameStatus: "success",
          mailToStatus: "success",
        });
      });
    } else {
      setmaildropData({
        preparedBy: {
          value: selectedtData.preparedBy?.id,
          label: selectedtData.preparedBy?.username,
        },
        userType: {
          value: selectedtData.userType,
          label: selectedtData.userType,
        },
        organizationName: {
          value: selectedtData.organisationName,
          label: selectedtData.organisationName,
        },
        name: {
          value: selectedtData.name,
          label: selectedtData.name,
        },
        mailFrom: selectedtData.fromEmail,
        mailTo: selectedtData.toEmail,
        mailType: {
          value: selectedtData.emailType,
          label: selectedtData.emailType,
        },
        purpose: {
          value: selectedtData.emailPurpose,
          label: selectedtData.emailPurpose,
        },
        description: selectedtData.emailDescription,
        preparedByStatus: "success",
        userTypeStatus: "success",
        nameStatus: "success",
        mailFromStatus: "success",
        mailToStatus: "success",
        mailTypeStatus: "success",
        purposeStatus: "success",
        organizationNameStatus: "success",
        descriptionStatus: "success",
      });
      setmailData({
        ...mailData,
        organizationName: selectedtData.organisationName,
        name: selectedtData.name,
        mailTo: selectedtData.toEmail,
        title: selectedtData.title,
        description: selectedtData.emailDescription,
        titleStatus: "success",
        descriptionStatus: "success",
        organizationNameStatus: "success",
        nameStatus: "success",
        mailToStatus: "success",
      });
    }

    setmailData({
      title: selectedtData.title,
      description: selectedtData.emailDescription,
      titleStatus: "success",
      mailTo: selectedtData.toEmail,
      descriptionStatus: "success",
    });
  };

  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);


  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <DashboardLayout>
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h6" fontWeight="medium">
                        Mail Log details
                      </MaterialTypography>
                    </Stack>
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Loading button group"
                    >
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={toggleEdit}
                        startIcon={<EditIcon />}
                      >
                        Edit
                      </MaterialButton>
                    </ButtonGroup>
                  </Stack>
                ) : togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h6" fontWeight="medium">
                        Edit Mail Log
                      </MaterialTypography>
                    </Stack>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h6" fontWeight="medium">
                        Add Mail Log
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent sx={{ minHeight: "80vh" }}>
            <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                    <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                    <MaterialTypography
                                    sx={{color:'#460058',fontFamily:'Aptos'}}
                                      component="label"
                                      variant="body2"
                                      fontWeight="700"
                                    >
                                      Mail Information
                                    </MaterialTypography>
                                  </Stack>

            <MaterialBox>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Associated By <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="preparedBy"
                    customStyles={{ optionPadding: 20 }}
                    value={maildropData.preparedBy}
                    onChange={handleMailDataChange}
                    options={preferdOption?.map((item) => {
                      return {
                        value: item?.id,
                        label: item?.username,
                      };
                    })}
                    error={
                      maildropData.preparedByStatus === "error" ? true : false
                    }
                    success={
                      maildropData.preparedByStatus === "success" ? true : false
                    }
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      User Type <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="userType"
                    value={maildropData.userType}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleMailDataChange}
                    options={useroptions?.map((item) => {
                      return {
                        value: item?.value,
                        label: item?.label,
                      };
                    })}
                    error={
                      maildropData.userTypeStatus === "error" ? true : false
                    }
                    success={
                      maildropData.userTypeStatus === "success" ? true : false
                    }
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                </Grid2>
                <Grid2 size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Organization Name<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  {isOtherUserType ? (
                    <>
                      <MaterialInput
                        name="organizationName"
                        placeholder=" Organization Name..."
                        value={mailData.organizationName}
                        onChange={handleMailChange}
                        error={
                          mailData.organizationNameStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          mailData.organizationNameStatus === "success"
                            ? true
                            : false
                        }
                        disabled={togglePage?.view === true ? true : false}
                      />
                      {mailData.organizationNameStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            {mailData.organizationNameErrorMessage}
                          </FormHelperText>
                        </FormControl>
                      )}
                    </>
                  ) : (
                    <MaterialSelect
                      name="organizationName"
                      customStyles={{ optionPadding: 20 }}
                      onChange={handleMailDataChange}
                      value={maildropData.organizationName}
                      options={dropOption?.map((item) => {
                        return {
                          value: item?.id,
                          label: item?.legalName || item?.companyName,
                        };
                      })}
                      error={
                        maildropData.organizationNameStatus === "error"
                          ? true
                          : false
                      }
                      success={
                        maildropData.organizationNameStatus === "success"
                          ? true
                          : false
                      }
                      isDisabled={togglePage?.view === true ? true : false}
                    />
                  )}
                </Grid2>
                <Grid2 size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Task Title<span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      name="taskTitle"
                      options={titleOptions}
                      value={taskData.taskTitle}
                      onChange={handleTaskTitle}
                      error={taskData.taskTitleStatus === "error"}
                      success={taskData.taskTitleStatus === "success"}
                      isDisabled={togglePage?.view === true ? true : false}
                    />
                 
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Contact Name
                    </MaterialTypography>
                  </MaterialBox>
                  {isOtherUserType ? (
                    <>
                      <MaterialInput
                        name="name"
                        placeholder=" Name..."
                        value={mailData.name}
                        customStyles={{ optionPadding: 20 }}
                        onChange={handleMailChange}
                        error={mailData.nameStatus === "error"}
                        success={mailData.nameStatus === "success"}
                        disabled={togglePage?.view === true ? true : false}
                      />
                      {mailData.nameStatus === "error" &&
                        mailData.nameErrorMessage && (
                          <FormControl error>
                            <FormHelperText>
                              {mailData.nameErrorMessage}
                            </FormHelperText>
                          </FormControl>
                        )}
                    </>
                  ) : (
                    <MaterialSelect
                      name="name"
                      value={maildropData.name}
                      customStyles={{ optionPadding: 20 }}
                      onChange={handleMailDataChange}
                      options={dropOptionName?.map((item) => {
                        return {
                          value: item?.id,
                          label: item?.firstName,
                        };
                      })}
                      error={maildropData.nameStatus === "error" ? true : false}
                      success={
                        maildropData.nameStatus === "success" ? true : false
                      }
                      isDisabled={togglePage?.view === true ? true : false}
                    />
                  )}
                </Grid2>

                <Grid2 size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Email From
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="mailFrom"
                    placeholder="mail from..."
                    value={maildropData.mailFrom}
                    onChange={handleMailDataChange}
                    error={
                      maildropData.mailFromStatus === "error" ? true : false
                    }
                    success={
                      maildropData.mailFromStatus === "success" ? true : false
                    }
                    disabled={true}
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                </Grid2>
                <Grid2 size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Email To<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  {isOtherUserType ? (
                    <>
                      <MaterialInput
                        name="mailTo"
                        placeholder="Mail To..."
                        value={mailData.mailTo || ""}
                        customStyles={{ optionPadding: 20 }}
                        onChange={handleMailChange}
                        error={mailData.mailToStatus === "error" ? true : false}
                        success={
                          mailData.mailToStatus === "success" ? true : false
                        }
                        disabled={togglePage?.view === true ? true : false}
                      />
                      {mailData.mailToStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Please enter a valid email address
                          </FormHelperText>
                        </FormControl>
                      )}
                    </>
                  ) : (
                    <MaterialInput
                      name="mailTo"
                      placeholder="Mail To..."
                      value={maildropData.mailTo}
                      onChange={handleMailDataChange}
                      error={
                        maildropData.mailToStatus === "error" ? true : false
                      }
                      success={
                        maildropData.mailToStatus === "success" ? true : false
                      }
                      disabled={true}
                      isDisabled={togglePage?.view === true ? true : false}
                    />
                  )}
                </Grid2>
              </Grid2>
              <Divider />
              <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                      <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                      <MaterialTypography
                                      sx={{color:'#460058',fontFamily:'Aptos'}}
                                        component="label"
                                        variant="body2"
                                        fontWeight="700"
                                      >
                                        Mail Type Information
                                      </MaterialTypography>
                                    </Stack>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Title<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="title"
                    placeholder="Title..."
                    value={mailData.title}
                    onChange={handleMailChange}
                    error={mailData.titleStatus === "error" ? true : false}
                    success={mailData.titleStatus === "success" ? true : false}
                    disabled={togglePage?.view === true}
                  />
                  {mailData.titleStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        PAN Number should be maximum 10 characters long
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Email Type <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="mailType"
                    value={maildropData.mailType}
                    onChange={handleMailDataChange}
                    options={mailType?.map((item) => {
                      return {
                        value: item?.value,
                        label: item?.label,
                      };
                    })}
                    error={
                      maildropData.mailTypeStatus === "error" ? true : false
                    }
                    success={
                      maildropData.mailTypeStatus === "success" ? true : false
                    }
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Purpose<span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="purpose"
                    value={maildropData.purpose}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleMailDataChange}
                    options={purposeOptions?.map((item) => {
                      return {
                        value: item?.value,
                        label: item?.label,
                      };
                    })}
                    error={
                      maildropData.purposeStatus === "error" ? true : false
                    }
                    success={
                      maildropData.purposeStatus === "success" ? true : false
                    }
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Description
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    name="description"
                    placeholder="Write description..."
                    multiline
                    rows={3}
                    value={mailData.description}
                    onChange={handleMailChange}
                    error={
                      mailData.descriptionStatus === "error" ? true : false
                    }
                    success={
                      mailData.descriptionStatus === "success" ? true : false
                    }
                    disabled={togglePage?.view === true}
                  />
                  {mailData.descriptionStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Description should be maximum 50 characters long
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid2>
              </Grid2>
              <MaterialBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                {togglePage.edit === true ? (
                  <>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDiscardButton}
                    >
                      Discard
                    </MaterialButton>
                    <MaterialButton
                      sx={{ m: 2 }}
                      variant="gradient"
                      color="dark"
                      disabled={!checkAllFields()}
                      onClick={handleUpdateMail}
                    >
                      Update
                    </MaterialButton>
                  </>
                ) : togglePage.view === false && togglePage.edit === false ? (
                  <>
                    <MaterialButton
                      sx={{ m: 2 }}
                      variant="gradient"
                      color="dark"
                      disabled={!checkAllFields()}
                      onClick={handleAddMail}
                    >
                      Submit
                    </MaterialButton>

                    <MaterialButton
                      sx={{ m: 2 }}
                      variant="gradient"
                      color="dark"
                      onClick={handleCancelMailData}
                    >
                      Cancel
                    </MaterialButton>
                  </>
                ) : null}
              </MaterialBox>
            </MaterialBox>
          </CardContent>
        </Card>
      </DashboardLayout>
    </>
  );
};

export default AddMail;
